var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from "vue-facing-decorator";
import { LicenseClient } from "@/app/api/battery-portal-api";
const licenseClient = new LicenseClient(window.apiUrl);
let SystemCoverageModal = class SystemCoverageModal extends Vue {
    constructor() {
        super(...arguments);
        this.loaded = false;
        this.show = false;
        this.systemCoverage = null;
        this.systemsFilter = "";
    }
    showModal() {
        this.loaded = false;
        this.show = true;
        this.systemsFilter = "";
        this.fetchSystemCoverage();
    }
    fetchSystemCoverage() {
        licenseClient
            .getSystemCoverage()
            .then(response => {
            this.systemCoverage = response;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.loaded = true;
        });
    }
    get hasUnlicensedSystems() {
        var _a, _b;
        return ((_b = (_a = this.systemCoverage) === null || _a === void 0 ? void 0 : _a.unlicensedSystemCount) !== null && _b !== void 0 ? _b : 0) > 0;
    }
    get filteredSystems() {
        var _a;
        if (!((_a = this.systemCoverage) === null || _a === void 0 ? void 0 : _a.systems))
            return [];
        const filter = this.systemsFilter.toLowerCase().trim();
        if (!filter)
            return this.systemCoverage.systems;
        return this.systemCoverage.systems.filter(system => {
            var _a, _b, _c;
            return ((_a = system.systemName) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(filter)) ||
                ((_b = system.companyName) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(filter)) ||
                ((_c = system.siteName) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(filter));
        });
    }
};
SystemCoverageModal = __decorate([
    Component({
        expose: ["showModal"]
    })
], SystemCoverageModal);
export default SystemCoverageModal;
